import m from "../../geodata/es2015/russiaHigh";
window.am4geodata_russiaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/russiaHigh.js
// module id = null
// module chunks = 